import { render } from "./ItemModal.vue?vue&type=template&id=0d5d221f&scoped=true"
import script from "./ItemModal.vue?vue&type=script&lang=js"
export * from "./ItemModal.vue?vue&type=script&lang=js"

import "@/assets/css/shared/itemModal.css?vue&type=style&index=0&id=0d5d221f&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5d221f"],['__file',"src/components/sharedAccordionDetail/ItemModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d5d221f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d5d221f', __exports__)) {
    api.reload('0d5d221f', __exports__)
  }
  
  module.hot.accept("./ItemModal.vue?vue&type=template&id=0d5d221f&scoped=true", () => {
    api.rerender('0d5d221f', render)
  })

}


export default __exports__